// extracted by mini-css-extract-plugin
export default {"textarea":"styles__textarea--Q9U8I","disabled":"styles__disabled--zs1tz"};